import * as React from "react";
import { Text } from "react-native";

export default function (props) {
  return (
    <Text
      {...props}
      style={[
        {
          paddingLeft: 5,
          paddingRight: 5,
          color: "#3E4672",
          fontFamily: "Montserrat-Regular",
          fontSize: 18,
          textAlign: "center",
          marginTop: 20,
        },
        props.style,
      ]}>
      {props.children}
    </Text>
  );
}
